import React, { forwardRef } from 'react';
import { AdapterDateFns } from '@mui/x-date-pickers/AdapterDateFns';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { DatePicker } from '@mui/x-date-pickers/DatePicker';
import { Path, Svg } from 'react-native-svg';
import { colors } from '../../../../shared/theme/colors';
import { format, isValid, parse } from 'date-fns';
const slots = {
  leftArrowIcon: () => /*#__PURE__*/React.createElement(Svg, {
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none"
  }, /*#__PURE__*/React.createElement(Path, {
    d: "M16 8l-1.41-1.41L9 12.17V0H7v12.17L1.42 6.58 0 8l8 8 8-8z",
    fill: "#212121"
  })),
  rightArrowIcon: () => /*#__PURE__*/React.createElement(Svg, {
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none"
  }, /*#__PURE__*/React.createElement(Path, {
    d: "M0 8l1.41 1.41L7 3.83V16h2V3.83l5.58 5.59L16 8 8 0 0 8z",
    fill: "#212121"
  }))
};
export default /*#__PURE__*/forwardRef((_ref, ref) => {
  let {
    value,
    onChange
  } = _ref;
  return /*#__PURE__*/React.createElement(LocalizationProvider, {
    dateAdapter: AdapterDateFns
  }, /*#__PURE__*/React.createElement(DatePicker, {
    autoFocus: true,
    inputRef: ref,
    value: parse(value, 'yyyy-MM-dd', new Date()),
    onChange: newValue => {
      if (newValue && isValid(newValue)) {
        onChange(format(newValue, 'yyyy-MM-dd'));
      } else onChange('');
    },
    slots: slots,
    slotProps: {
      actionBar: {
        actions: ['today']
      },
      layout: {
        sx: {
          '.Mui-selected': {
            borderRadius: '0',
            border: `2px solid ${colors.primary[500]}`,
            backgroundColor: `${colors.primary[800]} !important`,
            color: colors.white[500]
          },
          '.MuiPickersDay-today': {
            borderRadius: '0',
            backgroundColor: `${colors.white[500]} !important`,
            border: `1px solid ${colors.primary[800]} !important`
          },
          '.MuiPickersYear-yearButton': {
            '&:hover': {
              borderRadius: '0',
              backgroundColor: `${colors.primary[800]} !important`,
              border: `2px solid ${colors.primary[500]}`,
              color: colors.white[500]
            }
          },
          '.MuiPickersDay-root': {
            '&:hover': {
              borderRadius: '0',
              border: `2px solid ${colors.primary[500]}`,
              backgroundColor: `${colors.primary[800]} !important`,
              color: colors.white[500]
            }
          },
          '.MuiDialogActions-root .MuiButton-text': {
            '&:hover': {
              borderRadius: '0',
              backgroundColor: `${colors.primary[800]} !important`,
              border: `2px solid ${colors.primary[500]}`,
              color: colors.white[500]
            }
          }
        }
      }
    },
    sx: {
      'height': '3.4375rem',
      '.MuiOutlinedInput-root': {
        borderRadius: '2px'
      },
      '.MuiOutlinedInput-notchedOutline': {
        border: `1px solid ${colors.blue[600]}`
      }
    }
  }));
});
//# sourceMappingURL=index.js.map